import React from 'react';
import ExpenseManagementPanel from '../ExpenseManagementPanel';

const FinancialExpensesWorkspace = ({
  expenses,
  categories,
  suppliers,
  paymentMethods,
  periodParams,
  formatCurrency,
  onReload,
  toast
}) => {
  return (
    <ExpenseManagementPanel
      expenses={expenses}
      categories={categories}
      suppliers={suppliers}
      paymentMethods={paymentMethods}
      periodParams={periodParams}
      formatCurrency={formatCurrency}
      onReload={onReload}
      toast={toast}
    />
  );
};

export default FinancialExpensesWorkspace;
